import * as React from 'react';
import {ImageStyle, StyleProp, StyleSheet} from 'react-native';
import {Text, Image} from 'native-base';
import {message} from '../../../utils/messages';

interface IProps {
  marginTop?: number;
  customStyles?: StyleProp<ImageStyle>;
  customFontSize?: number;
}

export default (props: IProps) => {
  const {marginTop, customStyles, customFontSize} = props;
  return (
    <>
      <Image
        source={require('./images/empty_list.png')}
        style={customStyles ? customStyles : styles.image}
        marginTop={marginTop ?? 100}
        alt="empty"
      />
      <Text
        color="blue.400"
        fontWeight="extrabold"
        fontSize={customFontSize ?? 'lg'}
        alignSelf="center">
        {message('empty-list-message')}
      </Text>
    </>
  );
};

const styles = StyleSheet.create({
  image: {
    width: 200,
    height: 200,
    alignSelf: 'center',
  },
});
